class ConsumersQueryController  {
    constructor(AutoQuery) {
        let options = {
            url: 'QueryConsumers.json?Fields=Id,CompanyName,Address,Address2,City,State,Zip,Status',
            pageSize: 24,
            orderBy: 'Id',
            autoLoad: true,
            append: false,
            sortOptions: {
                'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
                'CompanyName': 'Name: A to Z',
                '-CompanyName': 'Name: Z to A',
                'Address': 'Address: A to Z',
                '-Address': 'Address: Z to A',
                'Address2': 'Address2: A to Z',
                '-Address2': 'Address2: Z to A',
                'City': 'City: A to Z',
                '-City': 'City: Z to A',
                'State': 'State: A to Z',
                '-State': 'State: Z to A',
                'Zip': 'Zip: 1 to 9',
                '-Zip': 'Zip: 9 to 1',
                'Status': 'Status: A to Z',
                '-Status': 'Status: Z to A'
            }
        };
        this.consumersQuery = new AutoQuery(options);
    }
}

let ConsumersQuery = {
    bindings: {
    },
    controller: ConsumersQueryController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumers-query.html'
    }
}

angular.module('emun.consumer').component('consumersQuery', ConsumersQuery);
